/* ============ BOREDUMB — Shopify theme interactions ============ */
(function(){
  /* ---------- motion ---------- */
  function getMotion(){ return document.body.dataset.motion || 'playful'; }

  /* ---------- ambient gooey blobs ---------- */
  function placeBlobs(container, specs){
    if(!container) return;
    container.innerHTML = '';
    specs.forEach((s, i) => {
      const b = document.createElement('span');
      b.style.left = s.x; b.style.top = s.y; b.style.width = s.d; b.style.height = s.d;
      b.style.animation = (i%2 ? 'floatB':'floatA') + ' var(--float-dur) ease-in-out infinite';
      b.style.animationDelay = (-i*1.3)+'s';
      container.appendChild(b);
    });
  }
  placeBlobs(document.querySelector('.splash-goo'), [
    {x:'30%',y:'24%',d:'120px'},{x:'58%',y:'40%',d:'170px'},{x:'44%',y:'58%',d:'90px'},{x:'66%',y:'22%',d:'70px'}
  ]);
  placeBlobs(document.querySelector('.hero-goo'), [
    {x:'8%',y:'18%',d:'180px'},{x:'78%',y:'30%',d:'220px'},{x:'62%',y:'66%',d:'120px'},{x:'20%',y:'70%',d:'150px'},{x:'40%',y:'10%',d:'90px'}
  ]);

  /* ---------- splash: shows on EVERY visit ---------- */
  const splash = document.getElementById('splash');
  if(splash){
    const drips = splash.querySelector('.drips');
    if(drips){ [60,110,80,140,70,120,90,150,75,115,85,130].forEach(h => { const i=document.createElement('i'); i.style.height=h+'px'; drips.appendChild(i); }); }
    let entered = false;
    function enter(){
      if(entered) return; entered = true;
      splash.classList.add('gone');
      document.body.style.overflow = '';
      setTimeout(()=> splash.remove(), 1400);
    }
    document.body.style.overflow = 'hidden';
    splash.addEventListener('click', enter);
    window.addEventListener('keydown', e => { if(e.key==='Enter'||e.key===' ') enter(); });
  }

  /* ---------- marquee ---------- */
  document.querySelectorAll('.marquee-track').forEach(tr => { tr.innerHTML = tr.innerHTML + tr.innerHTML; });

  /* ---------- scroll reveal (bulletproof) ---------- */
  function revealInView(){
    const vh = window.innerHeight || document.documentElement.clientHeight;
    document.querySelectorAll('.reveal:not(.in)').forEach(el => {
      const r = el.getBoundingClientRect();
      if(r.top < vh * 0.92 && r.bottom > 0) el.classList.add('in');
    });
  }
  window.addEventListener('scroll', revealInView, { passive: true });
  window.addEventListener('resize', revealInView);
  window.addEventListener('load', revealInView);
  revealInView();
  setTimeout(revealInView, 1200);

  /* ---------- toast ---------- */
  let toastEl;
  function toast(msg){
    if(!toastEl){ toastEl = document.createElement('div'); toastEl.id = 'bd-toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(()=> toastEl.classList.remove('show'), 2000);
  }

  /* ---------- live bag count (Shopify) ---------- */
  async function refreshCart(){
    try{
      const res = await fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
      const cart = await res.json();
      document.querySelectorAll('[data-bag-count]').forEach(el => el.textContent = cart.item_count);
    }catch(e){}
  }

  /* ---------- money (basic; assumes 2 decimals) ---------- */
  function money(cents){
    const sym = (window.Shopify && Shopify.currency && Shopify.currency.active) ? '' : '$';
    return sym + (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (sym ? '' : '');
  }

  /* ---------- PRODUCT PAGE ---------- */
  const pdp = document.getElementById('pdp');
  if(pdp){
    let variants = [];
    try { variants = JSON.parse(document.getElementById('pdp-variants').textContent); } catch(e){}
    const variantInput = document.getElementById('variant-id');
    const priceEl = document.getElementById('pdp-price');
    const addBtn = document.getElementById('pdp-add');
    const qtyInput = document.getElementById('quantity-input');
    const qtyDisp = pdp.querySelector('[data-qty]');

    function selectedValues(){
      const groups = [...pdp.querySelectorAll('[data-opt-index]')]
        .sort((a,b)=> a.dataset.optIndex - b.dataset.optIndex);
      return groups.map(g => { const on = g.querySelector('.is-on'); return on ? on.dataset.value : null; });
    }
    function findVariant(vals){
      return variants.find(v => v.options.every((o,i)=> vals[i]==null || o === vals[i]));
    }
    function syncVariant(){
      const v = findVariant(selectedValues());
      if(!v) return;
      variantInput.value = v.id;
      if(priceEl) priceEl.textContent = money(v.price);
      const lab = pdp.querySelector('[data-color-label]');
      const vals = selectedValues();
      if(lab){ const ci = [...pdp.querySelectorAll('.swatches')][0]; if(ci){ const idx = +ci.dataset.optIndex; if(vals[idx]) lab.textContent = vals[idx]; } }
      if(addBtn){
        if(v.available){ addBtn.disabled = false; addBtn.textContent = 'Add to Cart — ' + money(v.price); }
        else { addBtn.disabled = true; addBtn.textContent = 'Sold Out'; }
      }
    }
    pdp.querySelectorAll('[data-opt-index]').forEach(group => {
      group.querySelectorAll('.size-btn, .sw').forEach(btn => btn.addEventListener('click', () => {
        group.querySelectorAll('.size-btn, .sw').forEach(b => b.classList.remove('is-on'));
        btn.classList.add('is-on'); syncVariant();
      }));
    });

    // qty
    pdp.querySelectorAll('[data-qstep]').forEach(b => b.addEventListener('click', () => {
      let q = Math.max(1, parseInt(qtyInput.value||'1',10) + parseInt(b.dataset.qstep,10));
      qtyInput.value = q; if(qtyDisp) qtyDisp.textContent = q;
    }));

    // thumbnails
    const mainImg = document.getElementById('pdp-main-img');
    pdp.querySelectorAll('.pdp-thumb').forEach(t => t.addEventListener('click', () => {
      pdp.querySelectorAll('.pdp-thumb').forEach(x => x.classList.remove('is-on'));
      t.classList.add('is-on');
      if(mainImg && t.dataset.img) mainImg.src = t.dataset.img;
    }));

    // accordions
    pdp.querySelectorAll('.acc-head').forEach(h => h.addEventListener('click', () => h.parentElement.classList.toggle('open')));

    // add to cart (AJAX)
    const form = document.getElementById('product-form');
    if(form){
      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        const id = variantInput.value;
        const qty = parseInt(qtyInput.value||'1',10);
        if(!id){ toast('Pick a size first'); return; }
        addBtn.disabled = true;
        try{
          const res = await fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept':'application/json' },
            body: JSON.stringify({ id: id, quantity: qty })
          });
          if(!res.ok){ const err = await res.json(); toast(err.description || 'Could not add to cart'); }
          else { toast('Added to cart ✓'); await refreshCart(); }
        }catch(err){ toast('Could not add to cart'); }
        addBtn.disabled = false;
      });
    }
    syncVariant();
  }

  /* ---------- CART PAGE qty steppers (submit native cart form) ---------- */
  document.querySelectorAll('.cart-form [data-cstep]').forEach(btn => btn.addEventListener('click', () => {
    const row = btn.closest('.qty');
    const input = row.querySelector('[data-cqty]');
    let q = Math.max(0, parseInt(input.value||'0',10) + parseInt(btn.dataset.cstep,10));
    input.value = q;
    const form = btn.closest('.cart-form');
    const upd = form.querySelector('[name="update"]');
    if(upd) upd.click();
  }));

  /* ---------- magnetic blob buttons (desktop) ---------- */
  const fine = window.matchMedia('(pointer:fine)').matches;
  if(fine){
    document.querySelectorAll('.blob-btn').forEach(btn => {
      btn.addEventListener('mousemove', e => {
        if(getMotion()==='off') return;
        const r = btn.getBoundingClientRect();
        const mx = (e.clientX - r.left - r.width/2) / r.width;
        const my = (e.clientY - r.top - r.height/2) / r.height;
        btn.style.transform = 'translate(' + (mx*8) + 'px,' + (my*8) + 'px) scale(1.04)';
      });
      btn.addEventListener('mouseleave', () => { btn.style.transform = ''; });
    });
  }

  /* ---------- cursor goo trail ---------- */
  let gooLayer = document.getElementById('goo-layer');
  let trail = [], rafOn = false, mouse = {x:-200,y:-200};
  function setupGooLayer(){
    const m = getMotion();
    const on = fine && (m==='playful' || m==='chaotic');
    if(!gooLayer) return;
    if(on){
      if(trail.length===0){
        const n = m==='chaotic' ? 5 : 3;
        for(let i=0;i<n;i++){ const s=document.createElement('span'); const d=26-i*4; s.style.width=d+'px'; s.style.height=d+'px'; gooLayer.appendChild(s); trail.push({el:s,x:mouse.x,y:mouse.y}); }
      }
      gooLayer.style.display='block'; if(!rafOn){ rafOn=true; loop(); }
    } else { gooLayer.style.display='none'; gooLayer.innerHTML=''; trail=[]; rafOn=false; }
  }
  function loop(){
    if(!rafOn) return;
    let px=mouse.x, py=mouse.y;
    trail.forEach((t,i)=>{
      t.x += (px - t.x) * (0.35 - i*0.04); t.y += (py - t.y) * (0.35 - i*0.04);
      t.el.style.transform = 'translate(' + (t.x - parseFloat(t.el.style.width)/2) + 'px,' + (t.y - parseFloat(t.el.style.height)/2) + 'px)';
      px = t.x; py = t.y;
    });
    requestAnimationFrame(loop);
  }
  window.addEventListener('mousemove', e => { mouse.x=e.clientX; mouse.y=e.clientY; });

  /* ---------- mobile menu ---------- */
  const menuBtn = document.querySelector('.menu-btn');
  const navEl = document.querySelector('header.nav');
  if(menuBtn && navEl){ menuBtn.addEventListener('click', () => navEl.classList.toggle('open')); }

  setupGooLayer();
})();
